"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optionsContainer = exports.clickableWrapper = exports.positionContainer = void 0;

var _util = require("../../../util");

const positionContainer = ({
  theme
}) => ({
  background: (0, _util.color)(theme, 'background.tan2'),
  borderRadius: (0, _util.spacing)(theme, ['small', 'small', 0, 0]),
  boxShadow: (0, _util.boxShadow)(theme, [0, 0, 0, 0.5, 'ui4', true])
});

exports.positionContainer = positionContainer;

const clickableWrapper = () => ({
  cursor: 'pointer'
});

exports.clickableWrapper = clickableWrapper;

const optionsContainer = ({
  theme,
  cssProps: {
    isSelected
  }
}) => ({
  margin: 0,
  background: (0, _util.color)(theme, isSelected ? 'interactive.row.hover' : 'background.default'),
  borderRadius: (0, _util.spacing)(theme, [0, 0, 'small', 'small']),
  border: "1px solid ".concat((0, _util.color)(theme, 'interactive.ui.grey2')),
  boxShadow: (0, _util.boxShadow)(theme, [0, 0, 0, 0.5, 'ui4', true])
});

exports.optionsContainer = optionsContainer;
//# sourceMappingURL=StrategyPosition.style.js.map